module.exports = __webpack_public_path__ + "img/banner.6c510549.jpg";